// extracted by mini-css-extract-plugin
export default {"tabs":"Documentation_tabs__fQMUl","jobsContainer":"Documentation_jobsContainer__OaOah"};